module.exports = __webpack_public_path__ + "media/assets/images/blog/certifications-small-eefd44135ac7b5ed648fbc99bb355cde.jpg";